import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
}), 'LaptopChromebookOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LaptopChromebookOutlined.js
// module id = 4402
// module chunks = 2